import { useState } from 'react';

import { copy } from '~/components/copy-to-clipboard/utils/copy';

import { ConversationTask } from '../use-chat/use-chat.types';
import { useVisualizationStore } from '../use-visualization-store/useVisualizationStore';
import { CopyAction, copyResearchMessage } from '../utils/copyResearchMessage';
import { useConversationInventory } from './useConversationInventory';
import { useFormattedInventory } from './useFormattedInventory';

interface UseCopyConversationParams {
  task: ConversationTask;
  questionOnly: boolean;
  showingSteps: boolean;
  conversationId: string;
  action: CopyAction;
}

export const useCopyConversation = ({
  task,
  questionOnly,
  showingSteps,
  conversationId,
  action,
}: UseCopyConversationParams) => {
  const [isCopied, setIsCopied] = useState(false);

  const { data: inventory } = useConversationInventory(conversationId, true);

  const formattedInventory = useFormattedInventory(inventory);

  const { charts, tables } = useVisualizationStore(state => ({
    charts: state.charts,
    tables: state.tables,
  }));

  const handleCopy = async () => {
    if (questionOnly) {
      copy(task.input, task.input);
    } else {
      const states = task.states;

      if (states) {
        await copyResearchMessage({
          action,
          task: showingSteps
            ? task
            : { ...task, states: [states[states.length - 1]] },
          charts,
          tables,
          inventory: formattedInventory,
          taskQuestion: task.input,
        });
      }
    }

    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2_000);
  };

  return {
    isCopied,
    handleCopy,
  };
};
